import {
  Accordion as BaseAccordion,
  type AccordionProps,
} from "@src/appV2/redesign/system/ui-components";

import { ButtonInternalLink } from "./ButtonInternalLink";

export function Accordion(props: Omit<AccordionProps, "LinkComponent">) {
  return <BaseAccordion {...props} LinkComponent={ButtonInternalLink} />;
}
